module.exports = __webpack_public_path__ + "static/img/app-g.cae58c2.jpg";